import { lazy } from 'react';

import { retry } from 'app/utils/lib/file';

type ComponentProps = Record<string, unknown>;

const LazyFactorDebtorMatchingDashboardRoute = lazy(() =>
  retry(() => import('app/pages/admin/FactorDebtorMatching/Dashboard')));
const LazyFactorDebtorMatchingNextRoute = lazy(() =>
  retry(() => import('app/pages/admin/FactorDebtorMatching/Next')));
const LazyFactorDebtorMatchingShowRoute = lazy(() =>
  retry(() => import('app/pages/admin/FactorDebtorMatching/Show')));

export const FactorDebtorMatchingDashboard = (props: ComponentProps) =>
  <LazyFactorDebtorMatchingDashboardRoute {...props} />;
export const FactorDebtorMatchingNext = (props: ComponentProps) =>
  <LazyFactorDebtorMatchingNextRoute {...props} />;
export const FactorDebtorMatchingShow = (props: ComponentProps) =>
  <LazyFactorDebtorMatchingShowRoute {...props} />;
